import React, {useEffect, useState} from 'react';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import AppWrapper from './Components/AppWrapper';
import {MainMenu} from './MainMenu';
import classNames from 'classnames';
import {CloseCircleFilled} from '@ant-design/icons';
import Login from './Pages/Auth/Login';
import MobilePreview from './Pages/MobilePreview';
import {queryClient} from './Utils/common';
import {QueryClientProvider} from 'react-query';

enum NetWorkStatus {
    ONLINE = 'ONLINE',
    OFFLINE = 'OFFLINE',
    DEFAULT = 'DEFAULT',
}
function App() {
    const [online, setOnline] = useState(NetWorkStatus.DEFAULT);
    function onLine() {
        setOnline(NetWorkStatus.ONLINE);
    }
    function offLine() {
        setOnline(NetWorkStatus.OFFLINE);
    }
    useEffect(() => {
        window.addEventListener('online', onLine);
        window.addEventListener('offline', offLine);
        return () => {
            window.removeEventListener('online', onLine);
            window.removeEventListener('offline', offLine);
        };
    }, []);

    const router = createBrowserRouter([
        {
            path: '/login',
            element: <Login />,
        },
        {
            path: '/mobile/:url',
            element: <MobilePreview />,
        },
        ...MainMenu,
    ]);

    return (
        <AppWrapper menuItems={MainMenu}>
            <QueryClientProvider client={queryClient}>
                {online !== NetWorkStatus.DEFAULT && (
                    <div className={classNames('TIPS', online)}>
                        {online === NetWorkStatus.OFFLINE &&
                            '你的本地网络已断开，请检查网络连接,不要点击此页面任何位置，等待网络恢复后继续你的操作'}
                        {online === NetWorkStatus.ONLINE &&
                            '网络已恢复，可以继续你的操作，点击右侧关闭提示'}
                        {online === NetWorkStatus.ONLINE && (
                            <CloseCircleFilled
                                style={{marginLeft: 15}}
                                onClick={() => setOnline(NetWorkStatus.DEFAULT)}
                            />
                        )}
                    </div>
                )}
                <RouterProvider router={router} />
            </QueryClientProvider>
        </AppWrapper>
    );
}

export default App;
